export default __webpack_public_path__ + "static/media/line-chart-blue.5e94eee7.svg";